import { Card } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useCustomerValue } from "providers/CustomerContext";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  getInventorySKUList, getCustomerCode, getVendorCodeFromCustomer, getZone, getLocation, getOLN, getMLN, getCartonID, getDistinctSKUCode, getDistinctSKUCategory,
  getDistinctSKUGroup,
  getDistinctSKUSubgroup, getPhysicalCountList, getPhysicalCountList2, retrievePhysicalCountList, retrievePhysicalCountException
} from "services/data.inventory.service";
import { LoadingDialog } from "ui-components/Alert";
import { ListLayout } from "ui-components/Layout";
import ServerTable from "ui-components/tables/ServerTable";
import BasicTabs from "ui-components/tabs/BasicTabs";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { createSO } from "services/data.outbound.service";
import { InboundLayout } from "ui-components/Layout";
import { InboundHeaderCard } from "ui-components/Layout";
import { FormTitle, DatePickerField, Text, SelectField } from "ui-components/Form";
import { Grid, Icon } from "@mui/material";
//import SO from "./components/SO";
//import { headerRender, headerValues, headerValidation } from "./physical-count-schema";
import { SelectFields } from "ui-components/Form";
import { Fieldset } from "ui-components/Form";
import switchButton from "assets/theme/components/form/switchButton";
import Switch from "@mui/material/Switch";
import { SwitchField } from "ui-components/Form";
import { TableCard } from "ui-components/Layout";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import BasicTable from "ui-components/tables/BasicTable";
import { CustomSwitch } from "ui-components/CustomInput";
import { ReadonlyText } from "ui-components/Form";
import MDTypography from "components/MDTypography";
import { Formik, Form } from "formik";
import { uploadOB } from "services/data.outbound.service";
import { StripedDataGrid } from "ui-components/data-grids/StripedCheckboxDataGrid";
import { useTeamValue } from "providers/TeamContext";
import { CSVLink } from "react-csv";
import { ExportDialog } from "ui-components/Alert";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";

const tabs = ["Stock Available", "Out Of Stock", "Inactive"];

function OpeningBalance({ zoneLocationAisle }) {
  const { permissions, allowAll } = useTeamValue();
  const { customerCode } = useCustomerValue();
  const { vendorCode } = useState("");
  const [details, setDetails] = useState([]);
  const [alert, setAlert] = useState(null);
  const onError = (data) => {
    setAlert(<Error data={data} onChange={setAlert} />);
  };
  const [uploadResps, setUploadResps] = useState([]);
  const uploadOBMutation = useMutation(uploadOB, {});
  const uploadStatus = uploadOBMutation.status === "loading"
  const addPermission = allowAll || (Boolean(permissions["Opening Balance"]) && permissions["Opening Balance"].findIndex(b => b === "new") !== -1);
  const {downloadCsv, isDownloading} = useCsvDownloadHook();

  //added by leoliew
  const [criteriaCustomerVendor, setCriteriaCustomerVendor] = useState("Customer");
  const [criteriaZoneLocationAisle, setCriteriaZoneLocationAisle] = useState("Zone");
  const [criteriaZoneLocationAisle2, setCriteriaZoneLocationAisle2] = useState([]);
  const [criteriaSKUAttribute, setCriteriaSKUAttribute] = useState("");
  const [criteriaSortOrder, setcriteriaSortOrder] = useState("Ascending");
  const [temp, setTemp] = useState({ freeze: false, showSystemQuantity: false, excludeQuarantineItem: false })
  const [pickers, setPickers] = useState([]);
  const [type, setType] = useState("EXCEPTION");
  const [list, setList] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");
  const [olns, setOLNs] = useState([]);
  const [selectedOLN, setSelectedOLN] = useState("");
  const [mlns, setMLNs] = useState([]);
  const [selectedMLN, setSelectedMLN] = useState("");
  const [cartonids, setCartonIDs] = useState([]);
  const [selectedCartonID, setSelectedCartonID] = useState("");
  const [skucodes, setSKUCodes] = useState([]);
  const [selectedSKUCodes, setSelectedSKUCodes] = useState("");
  const [skucategories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [skugroups, setSKUGroups] = useState([]);
  const [selectedSKUGroup, setSelectedSKUGroup] = useState("");
  const [skusubgroups, setSKUSubgroups] = useState([]);
  const [selectedSKUSubgroup, setSelectedSKUSubgroup] = useState("");

  if (zoneLocationAisle && zoneLocationAisle.length) {
    console.log(zoneLocationAisle.length);
  } else {
    console.log('Object is undefined or has no length property');
  }

  const columns = [
    {
      accessorKey: "warehouseCode",
      header: "Warehouse ID",
      width: 150,
    },
    {
      accessorKey: "zoneID",
      header: "Zone ID",
      width: 150,
    },
    {
      accessorKey: "locationID",
      header: "Location ID",
      width: 150,
    },
    {
      accessorKey: "customerCode",
      header: "Customer Code",
      width: 200,
      align: "right",
    },
    {
      accessorKey: "vendorCode",
      header: "Vendor Code",
      width: 150,
    },
    {
      accessorKey: "skuCode",
      header: "SKU Code",
      width: 150,
      align: "right",
    },
  ];

  const createSOMutation = useMutation(createSO, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });

  const applyCriteriaSetting = (criteriaCustomerVendor, criteriaZoneLocationAisle2, criteriaSKUAttribute, criteriaSortOrder) => {
    resetVisibility();
    if (criteriaCustomerVendor !== null) {
      console.log("criteriaCustomerVendor is not null");
      console.log(criteriaCustomerVendor);
      if (criteriaCustomerVendor.value == "1") {
        console.log("customer only");
        refetch();
        //show customer dropdownlist
        //populate customer dropdownlist data
      }
      else if (criteriaCustomerVendor.value == "2") {
        console.log("customer and vendor");
        setVendorVisible(true);
        refetch();
        refetchVendor();
        //show customer and vendor dropdownlist
        //populate customer and vendor dropdownlist data
      }
    };
    if (criteriaZoneLocationAisle2 !== null) {
      console.log("criteriaZoneLocationAisle2 is not null");
      console.log(criteriaZoneLocationAisle2);
      if (criteriaZoneLocationAisle2.includes('Location')) {
        setLocationVisible(true);
        refetchLocation();
      }
      if (criteriaZoneLocationAisle2.includes('Zone')) {
        setZoneVisible(true);
        refetchZone();
      }
    };
    if (criteriaSKUAttribute !== null) {
      console.log("criteriaSKUAttribute is not null");
      console.log(criteriaSKUAttribute);
      if (criteriaSKUAttribute.includes('OLN')) {
        setOLNVisible(true);
        console.log("i enter oln");
        refetchOLN();
      }
      else if (criteriaSKUAttribute.includes('MLN')) {
        setMLNVisible(true);
        console.log("i enter mln");
        refetchMLN();
      }
      else if (criteriaSKUAttribute.includes('Carton ID')) {
        setCartonIDVisible(true);
        console.log("i enter cartonid");
        refetchCartonID();
      }
      else if (criteriaSKUAttribute.includes('SKU Code')) {
        setSKUCodeVisible(true);
        console.log("i enter skucode");
        if (vendorCode === undefined) {
          refetchSKUCode(customerCode);
          console.log('1');
        }
        else {
          refetchSKUCode(customerCode, selectedVendor);
          console.log('2');
        }
        console.log(selectedVendor);

      }
      else if (criteriaSKUAttribute.includes('SKU Category')) {
        setSKUCategoryVisible(true);
        console.log("i enter cateogry");
        refetchCategory(customerCode, "123");
      }
      else if (criteriaSKUAttribute.includes('SKU Group')) {
        setSKUGroupVisible(true);
        console.log("i enter skugroup");
        refetchSKUGroup(customerCode, vendorCode);
      }
      else if (criteriaSKUAttribute.includes('SKU Subgroup')) {
        setSKUSubgroupVisible(true);
        console.log("i enter skusubgroup");
        refetchSKUSubgroup(customerCode, vendorCode);
      }
    };
    if (criteriaSortOrder !== null) {
      console.log("criteriaSortOrder is not null");
    };
  };

  const { isFetching, refetch } = useQuery({
    queryKey: ["customerOption", { customerCode }],
    queryFn: () =>
      getCustomerCode(),
    //getVendorCodeFromCustomer(customerCode),
    enabled: false,
    onSuccess: (data) => setCustomers(data.data.data),
    //onSuccess: (data) => setVendors(data.data.data),
    onError,
  });

  const { isFetchingExceptionList, refetch: refetchExceptionList } = useQuery({
    //queryKey: ["exceptionlist"],
    queryFn: () => getPhysicalCountList(),
    enabled: false,
    onSuccess: (data) => setList(data.data.data),
  });

  // const { isFetchingExceptionList2,refetch:refetchExceptionList2 } = useMutation({
  //   queryKey: ["exceptionlist"],
  //   queryFn: () => getPhysicalCountList2({ 
  //     customerCode,
  //     vendorCode:selectedVendor,
  //     locationID:selectedLocation,
  //     zoneID:selectedZone,
  //     skuCode:selectedSKUCodes,
  //     category:selectedCategory,
  //     skuGroup:selectedSKUGroup,
  //     skuSubgroup:selectedSKUSubgroup,
  //     oln:selectedOLN,
  //     mln:selectedMLN,
  //     cartonID:selectedCartonID,
  //     freeze:temp.freeze,
  //     showSystemQuantity:temp.showSystemQuantity,
  //     hold:temp.excludeQuarantineItem,
  //     sortorder:criteriaSortOrder
  //    }),
  //   enabled: false,
  //   onSuccess: (data) => {
  //     console.log(data);
  //     const { pCountNo } = data.data; // Assuming the pCountNo is returned in the data object
  //     console.log("PCountNo:", pCountNo);
  //   retrievePhysicalCountList(pCountNo);
  //   //setList(data.data.data);
  // },
  // });

  const handleDownload = () => {
    retrievePhysicalCountException().then((response) => {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `PhysicalCountException.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  const getphysicalcountMutation = useMutation((requestdata) => getPhysicalCountList2(requestdata), {
    onSuccess: (data) => {
      if (data && data.data && data.data.pCountNo) {
        const { pCountNo } = data.data;
        console.log("PCountNo:", pCountNo);
        retrievePhysicalCountList(pCountNo).then((response) => {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${pCountNo}.xlsx`);
          document.body.appendChild(link);
          link.click();
        });
      }
      else {
        refetchExceptionList();
      }
      // queryClient.invalidateQueries(["exception-list"]);
      // setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });

  const ongetphysicalcountMutation = () => {
    console.log("inside on getphysicalcountmutation:");
    getphysicalcountMutation.mutate({
      customerCode,
      vendorCode: selectedVendor,
      locationID: selectedLocation,
      zoneID: selectedZone,
      skuCode: selectedSKUCodes,
      category: selectedCategory,
      skuGroup: selectedSKUGroup,
      skuSubgroup: selectedSKUSubgroup,
      oln: selectedOLN,
      mln: selectedMLN,
      cartonID: selectedCartonID,
      freeze: temp.freeze,
      showSystemQuantity: temp.showSystemQuantity,
      hold: temp.excludeQuarantineItem,
      sortorder: criteriaSortOrder
    });
  }

  const { isFetchingVendor, refetch: refetchVendor } = useQuery({
    queryKey: ["vendorOption", { customerCode }],
    queryFn: () =>
      getVendorCodeFromCustomer({
        customerCode
      }),
    enabled: false,
    onSuccess: (data) => setVendors(data.data.data),
    onError,
  });

  const { isFetchingLocation, refetch: refetchLocation } = useQuery({
    queryKey: ["locationOption", { customerCode }],
    queryFn: () =>
      getLocation(true),
    enabled: false,
    onSuccess: (data) => setLocations(data.data.data.map(x => x.locationID)),
    onError,
  });

  const { isFetchingZone, refetch: refetchZone } = useQuery({
    queryKey: ["zoneOption", { customerCode }],
    queryFn: () =>
      getZone(true),
    enabled: false,
    onSuccess: (data) => setZones(data.data.data.map(x => x.zoneID)),
    onError,
  });

  const { isFetchingOLN, refetch: refetchOLN } = useQuery({
    queryKey: ["olnOption", { customerCode }],
    queryFn: () =>
      getOLN(),
    enabled: false,
    onSuccess: (data) => setOLNs(data.data.data),
    onError,
  });

  const { isFetchingMLN, refetch: refetchMLN } = useQuery({
    queryKey: ["MLNOption", { customerCode }],
    queryFn: () =>
      getMLN(),
    enabled: false,
    onSuccess: (data) => setMLNs(data.data.data),
    onError,
  });

  const { isFetchingCartonID, refetch: refetchCartonID } = useQuery({
    queryKey: ["CartonIDOption", { customerCode }],
    queryFn: () =>
      getCartonID(),
    enabled: false,
    onSuccess: (data) => setCartonIDs(data.data.data),
    onError,
  });

  const { isFetchingSKUCode, refetch: refetchSKUCode } = useQuery({
    queryKey: ["SKUCodeOption", { customerCode }, { selectedVendor }],
    queryFn: () =>
      getDistinctSKUCode({
        customerCode,
        selectedVendor
      }),
    enabled: false,
    onSuccess: (data) => setSKUCodes(data.data.data),
    onError,
  });

  const { isFetchingCategory, refetch: refetchCategory } = useQuery({
    queryKey: ["SKUCategoryOption", { customerCode }, { selectedVendor }],
    queryFn: () =>
      getDistinctSKUCategory({
        customerCode,
        selectedVendor
      }),
    enabled: false,
    onSuccess: (data) => setCategories(data.data.data),
    onError,
  });

  const { isFetchingSKUGroup, refetch: refetchSKUGroup } = useQuery({
    queryKey: ["SKUGroupOption", { customerCode }, { selectedVendor }],
    queryFn: () =>
      getDistinctSKUGroup({
        customerCode,
        selectedVendor
      }),
    enabled: false,
    onSuccess: (data) => setSKUGroups(data.data.data),
    onError,
  });

  const { isFetchingSKUSubGroup, refetch: refetchSKUSubgroup } = useQuery({
    queryKey: ["SKUSubgroupOption", { customerCode }, { selectedVendor }],
    queryFn: () =>
      getDistinctSKUSubgroup({
        customerCode,
        selectedVendor
      }),
    enabled: false,
    onSuccess: (data) => setSKUSubgroups(data.data.data),
    onError,
  });

  // const onExport = () => {
  //   //setLoading(<LoadingDialog />);
  //   exportMutation.mutate(
  //     { customerCode, exceptionalType: type },
  //     {
  //       onSuccess: (data) => {
  //         const blob = new Blob([data.data]);
  //         const url = window.URL.createObjectURL(blob);
  //         const link = document.createElement("a");
  //         link.href = url;
  //         link.setAttribute("download", `${customerCode}_${type}.xlsx`);
  //         document.body.appendChild(link);
  //         link.click();
  //       },
  //     }
  //   );
  // };
  // const exportStatus = exportMutation.status === "loading";

  const handleSubmit = (values, actions) => {
    let formData = new FormData();
    formData.append("files", values.files[0], values.files[0].name);
    formData.append("customerCode", customerCode);
    formData.append("vendorCode", values.vendorCode);
    uploadOBMutation.mutate(formData, {
      onSuccess: (data) => {
        console.log("Success response:", data); // Log success response
        document.getElementById("files").value = null;
        //  document.getElementById("files").value = null;
        //  actions.setFieldValue("vendorCode", "");
        //  actions.resetForm();
        setUploadResps(data.data.data);
      },
      onError: (data) => {
        setAlert(<Error data={data} onChange={setAlert} />);
      },
    });
    actions.setSubmitting(false);
    // actions.resetForm(true);
  };

  const [isVendorVisible, setVendorVisible] = useState(false);
  const [isZoneVisible, setZoneVisible] = useState(false);
  const [isLocationVisible, setLocationVisible] = useState(false);
  const [isSKUCodeVisible, setSKUCodeVisible] = useState(false);
  const [isSKUCategoryVisible, setSKUCategoryVisible] = useState(false);
  const [isSKUGroupVisible, setSKUGroupVisible] = useState(false);
  const [isSKUSubgroupVisible, setSKUSubgroupVisible] = useState(false);
  const [isOLNVisible, setOLNVisible] = useState(false);
  const [isMLNVisible, setMLNVisible] = useState(false);
  const [isCartonIDVisible, setCartonIDVisible] = useState(false);

  const resetVisibility = () => {
    setVendorVisible(false);
    setZoneVisible(false);
    setLocationVisible(false);
    setSKUCodeVisible(false);
    setSKUCategoryVisible(false);
    setSKUGroupVisible(false);
    setSKUSubgroupVisible(false);
    setOLNVisible(false);
    setMLNVisible(false);
    setCartonIDVisible(false);
  };

  useEffect(() => {
    console.log("Selected Vendor:", selectedVendor);
    if (selectedVendor !== "") {
      refetchSKUCode();
    }
  }, [selectedVendor]);

  const handleDownloadTemplate = () => {
    window.open("/api/template/gettemplate?type=opening-balance");
  };

  return (
    <>
      {isFetching && isFetchingVendor && isFetchingLocation && isFetchingZone && isFetchingOLN && isFetchingMLN && isFetchingCartonID && isFetchingSKUCode && isFetchingCategory && isFetchingSKUGroup && isFetchingSKUSubGroup && <LoadingDialog />}
      <InboundLayout lg={12}>
        {alert}
        {isDownloading && <ExportDialog />}
        {uploadStatus && <LoadingDialog />}
        <InboundHeaderCard>
          <MDBox>
            <MDBox pb={1}>
              <MDTypography color="info" variant="h3">
                Upload Opening Balance
              </MDTypography>
              <br></br>
              <MDTypography color="default" variant="h3">
                Selected Customer: {customerCode}
              </MDTypography>
            </MDBox>
            <MDButton variant="gradient" color="info" onClick={handleDownloadTemplate}>
              Download Template
            </MDButton>

            <Formik initialValues={{ files: [] }} onSubmit={handleSubmit}>
              {({ values, isSubmitting, setFieldValue }) => (
                <Form style={{ paddingTop: "20px" }}>
                  <Grid item xs={6}>
                    {/* <Autocomplete
                      renderInput={(params) => (
                        <FormField {...params} label="Vendor Code *" name="vendorCode" required />
                      )}
                      options={vendorCodeOptions}
                      onChange={(e, option) => {
                        console.log(option);
                        setFieldValue("vendorCode", option);
                      }}
                    /> */}
                  </Grid>
                  <MDBox mt={2}>
                    <input
                      type="file"
                      name="files"
                      id="files"
                      onChange={(e) => {
                        setUploadResps([])
                        setFieldValue("files", e.target.files);
                      }}
                    />
                  </MDBox>
                  {/* {values.vendorCode}
                  {values.files.length} */}
                  <MDBox mt={2} display="flex" justifyContent="center">
                    <MDButton
                      type="submit"
                      variant="gradient"
                      color="info"
                      disabled={values.files.length == 0 || isSubmitting || !addPermission}
                    >
                      {isSubmitting ? "Uploading" : "Upload"}
                    </MDButton>
                  </MDBox>
                </Form>
              )}
            </Formik>
          </MDBox>
        </InboundHeaderCard>

        {uploadResps.length > 0 && (
          <InboundHeaderCard sx={{ height: "100%", marginTop: "2rem" }}>
            <MDTypography sx={{ marginBottom: ".5rem" }} color="info" variant="h4">
              Upload Response{" "}
              {/* <MDButton type="submit" variant="gradient" color="info">
                <Icon>download</Icon>&nbsp;
                <CSVLink
                  style={{ color: "white" }}
                  headers={[
                    {
                      label: "SKU Code",
                      key: "skuCode",
                    },
                    {
                      label: "Zone Id",
                      key: "zoneID",
                    },
                    {
                      label: "Location Id",
                      key: "locationID",
                    },
                    {
                      label: "Carton Id",
                      key: "cartonID",
                    },
                    {
                      label: "Quantity",
                      key: "sysQty",
                    },
                    {
                      label: "MLN",
                      key: "mln",
                    },
                    {
                      label: "Expiry Date",
                      key: "expiryDate",
                    },
                    {
                      label: "Manufacturing Date",
                      key: "manufacturingDate",
                    },
                    {
                      label: "Message",
                      key: "message",
                    },
                  ]}
                  filename={"upload_opening_balance_" + dayjs(new Date()).format("DD-MM-YYYY")}
                  data={uploadResps.filter((x) => !x.success)}
                >
                  Export
                </CSVLink>
              </MDButton> */}
              <MDButton
                type="submit" variant="gradient" color="info"
                onClick={() => {
                  const filename = `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_UploadOpeningBalance`;
                  const headers = [
                    {
                      label: "SKU Code",
                      key: "skuCode",
                    },
                    {
                      label: "Zone Id",
                      key: "zoneID",
                    },
                    {
                      label: "Location Id",
                      key: "locationID",
                    },
                    {
                      label: "Carton Id",
                      key: "cartonID",
                    },
                    {
                      label: "Quantity",
                      key: "sysQty",
                    },
                    {
                      label: "MLN",
                      key: "mln",
                    },
                    {
                      label: "Expiry Date",
                      key: "expiryDate",
                    },
                    {
                      label: "Manufacturing Date",
                      key: "manufacturingDate",
                    },
                    {
                      label: "Message",
                      key: "message",
                    },
                  ]
                  downloadCsv(filename, uploadResps.filter((x) => !x.success), headers)
                }}
              >
                <Icon>download</Icon>&nbsp;
                export
              </MDButton>
            </MDTypography>
            <StripedDataGrid
              columns={[
                {
                  headerName: "Status",
                  field: "success",
                  align: "center",
                  renderCell: (cell) =>
                    cell.row.success ? (
                      <StatusIcon color="success" icon="done" />
                    ) : (
                      <StatusIcon color="error" icon="close" />
                    ),
                },
                { headerName: "SKU Code", field: "skuCode", width: 100 },
                { headerName: "Zone Id", field: "zoneID", width: 100 },
                { headerName: "Location Id", field: "locationID", width: 100 },
                { headerName: "Carton Id", field: "cartonID", width: 100 },
                { headerName: "Quantity", field: "sysQty", width: 100 },
                { headerName: "MLN", field: "mln", width: 100 },
                { headerName: "Expiry Date", field: "expiryDate", width: 110 },
                { headerName: "Manu.Date", field: "manufacturingDate", width: 110 },
                // { headerName: "Cust Order Number", field: "custOrdNbr", width: 200 },
                {
                  headerName: "Message",
                  field: "message",
                  //flex: 1,
                  //wordWrapEnabled: true,
                  width: 750,
                  renderCell: (cell) => (
                    <div>
                      {cell.row.message.map((c, i) => (
                        <p key={i}>{c}</p>
                      ))}
                    </div>
                  ),
                },
              ]}
              rows={uploadResps}
              getRowHeight={(cell) => {
                if (cell.model.message.length > 2) {
                  return "auto";
                } else {
                  return 50;
                }
              }}
            />
          </InboundHeaderCard>
        )}
      </InboundLayout>
    </>
  );
}

const StatusIcon = ({ color, icon }) => (
  <MDButton color={color} variant="outlined" size="small" iconOnly circular>
    <Icon sx={{ fontWeight: "bold" }}>{icon}</Icon>
  </MDButton>
);

export default OpeningBalance;
